import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { components } from "react-select";
import Badge from "./Badge";
import CollapseGroup from "./CollapseGroup";
const MultiValue = (props) => {
    var _a, _b, _c;
    const { index, getValue, selectProps } = props;
    const { collapsedSelectedValues, collapseGroups, collapsedGroupState, onChange, } = selectProps;
    const selected = (typeof getValue === "function" ? getValue() : []);
    const maxToShow = 1;
    const overflow = selected
        .slice(maxToShow)
        .map((x) => x.label);
    const [first] = selected;
    if (collapsedSelectedValues === true) {
        return index < maxToShow ? (_jsx(components.MultiValue, Object.assign({}, props))) : index === maxToShow ? (_jsx(components.MultiValue, Object.assign({}, props, { children: _jsx(Badge, { items: overflow, firstValue: first === null || first === void 0 ? void 0 : first.value }) }))) : null;
    }
    // show collapse / expanding groups icon
    const multiVal = selected[index];
    if (collapseGroups && (multiVal === null || multiVal === void 0 ? void 0 : multiVal.groupLabel) !== undefined) {
        const label = multiVal.groupLabel;
        const firstIdxInGroup = selected.findIndex((o) => (o === null || o === void 0 ? void 0 : o.groupLabel) === label);
        const isFirstInGroup = index === firstIdxInGroup;
        const allOptions = selectProps.options;
        const groupOpt = Array.isArray(allOptions) &&
            allOptions.find((opt) => opt &&
                typeof opt === "object" &&
                opt.label === label &&
                Array.isArray(opt.options));
        const isMeta = (v) => typeof v === "string" &&
            (v === "all" ||
                v.startsWith("select-eco-group-") ||
                v.startsWith("remove-eco-group-") ||
                v.startsWith("loading-"));
        const childVals = new Set(((_a = groupOpt === null || groupOpt === void 0 ? void 0 : groupOpt.options) !== null && _a !== void 0 ? _a : [])
            .map((c) => c === null || c === void 0 ? void 0 : c.value)
            .filter((v) => v && !isMeta(v)));
        const selVals = new Set(selected.map((o) => o === null || o === void 0 ? void 0 : o.value).filter((v) => v && !isMeta(v)));
        const totalOptions = childVals.size;
        let selectedOptions = 0;
        for (const v of selVals)
            if (childVals.has(v))
                selectedOptions++;
        const collapsed = !!((_c = (_b = collapsedGroupState === null || collapsedGroupState === void 0 ? void 0 : collapsedGroupState.groups) === null || _b === void 0 ? void 0 : _b.find((g) => g.label === label)) === null || _c === void 0 ? void 0 : _c.collapsed);
        const group = collapsedGroupState.groups.find((grp) => grp.label === label);
        const collapsedProp = collapsed ? true : false;
        if (isFirstInGroup) {
            return (_jsxs(_Fragment, { children: [_jsx(props.components.Container, Object.assign({}, props, { children: _jsx(CollapseGroup, { label: label, collapseGroup: selectProps.collapseGroup, expandGroup: selectProps.expandGroup, collapsed: collapsedProp, selectedOptions: group === null || group === void 0 ? void 0 : group.selectedOptions, totalOptions: group === null || group === void 0 ? void 0 : group.totalOptions, onChange: onChange, optionSelected: selected }) })), !collapsed && _jsx(components.MultiValue, Object.assign({}, props))] }));
        }
        // if collapsed, return nothing
        return collapsed ? null : _jsx(components.MultiValue, Object.assign({}, props));
    }
    return _jsx(components.MultiValue, Object.assign({}, props));
};
export default MultiValue;
